import {Settings as MuiSettings} from "@mui/icons-material"
import {useState} from "react"

import {Certs} from "../../../features/cert/component/Certs"
import {ManageBackup} from "../../../features/management/component/ManageBackup"
import {ManageSecret} from "../../../features/management/component/ManageSecret"
import {Vault} from "../../../features/vault/component/Vault"
import {AlertAlign} from "../../../shared/component/box/AlertAlign"
import {DialogScreen} from "../../../shared/component/box/DialogScreen"
import {DialogButton} from "../../../shared/component/button/DialogButton"
import {Settings as SettingsType} from "../../../shared/helper/HelperType"
import {SettingOptions} from "../../../shared/helper/HelperUtils"
import {SettingsAbout} from "./SettingsAbout"
import {SettingsAccount} from "./SettingsAccount"
import {SettingsContent} from "./SettingsContent"
import {SettingsUser} from "./SettingsUser"

export function Settings() {
    const [page, setPage] = useState(SettingsType.MENU)

    return (
        <DialogButton
            title={SettingOptions[page].label}
            icon={<MuiSettings/>}
            back={page !== SettingsType.MENU}
            onBackClick={() => setPage(SettingsType.MENU)}
            onClose={() => setPage(SettingsType.MENU)}
            size={40}
        >
            <DialogScreen>{renderContent()}</DialogScreen>
        </DialogButton>
    )

    function renderContent() {
        switch (page) {
            case SettingsType.MENU:
                return <SettingsContent onUpdate={setPage}/>
            case SettingsType.VAULT:
                return <Vault/>
            case SettingsType.CERTIFICATE:
                return <Certs/>
            case SettingsType.SECRET:
                return <ManageSecret/>
            case SettingsType.ACCOUNT:
                return <SettingsAccount/>
            case SettingsType.USER:
                return <SettingsUser/>
            case SettingsType.BACKUP:
                return <ManageBackup/>
            case SettingsType.ABOUT:
                return <SettingsAbout/>
            default:
                return <AlertAlign text={"Not implemented yet"}/>
        }
    }
}
